module.exports = __webpack_public_path__ + "assets/images/diabetes_r.1d53801b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/diabetes_r.png
// module id = 699
// module chunks = 1